export default [
  'RegionDirectoryApi/queryRegionDirectoryTaskResult',
]